import axios from "axios";
export const uploadCommentAttachment = async (file, accessToken, idToken) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/comment-attachment/upload`;
  const formData = new FormData();
  formData.append("file", file);

  const headers = {
    Authorization: `Bearer ${accessToken}`,
    id_token: idToken,
    "Content-Type": "multipart/form-data",
  };

  try {
    const response = await axios.post(url, formData, { headers });
    return response.data.data; 
  } catch (error) {
    console.error("Comment attachment upload failed:", error);
    throw error;
  }
};
